(function () {

    /**
     * Initializes a hotspot content element and its hotspots
     * While it has not much functionality now it was separated to provide a good structure for future requirements
     * @param hotspotsElement
     * @constructor
     */
    function Hotspots(hotspotsElement) {

        var _this = this;

        this.init = function () {
            hotspots = $(hotspotsElement).find('.js-hotspots--hotspot-wrapper');
            hotspots.each(function () {
                new window.Juzo.Hotspot(this);
            });
        };

        _this.init();
    }

    window.Juzo = window.Juzo || {};

    window.Juzo.Hotspots = Hotspots;
})();



$(document).ready(function () {
    $('.js-hotspots--wrapper').each(function () {
        new window.Juzo.Hotspots(this);
    });
});